/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Invalidaspect1Inputs */

const de__filter_invalidaspect1 = /** @type {(inputs: _Filter_Invalidaspect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger Aspekt`)
};

/**

* @param {_Filter_Invalidaspect1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_invalidaspect1 = /** @type {((inputs?: _Filter_Invalidaspect1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Invalidaspect1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_invalidaspect1(inputs)
});
export { _filter_invalidaspect1 as "_filter_invalidAspect" }